<div class="modal-footer">
  <div class="modal-footer-inner">
    <div class="row align-items-center flex-fill">
      <div class="col">
        @if (showRequiredFieldsIndicator) {
          <scitis-required-field-indicator-explanation
          ></scitis-required-field-indicator-explanation>
        }
      </div>
      <div class="col-auto">

        @if (cancelButtonText!==null && showCancelButton) {
          <button (click)="onCancel()"
            [innerText]="cancelButtonText"
            class="btn btn-outline-primary mr-2"
            type="button">
          </button>
        }
        <button (click)="onOk()"
          [disabled]="disableOkButton"
          [innerText]="okButtonText"
          class="btn btn-primary"
          type="button">
        </button>
      </div>
    </div>
  </div>
</div>
